import { useTranslation } from 'react-i18next';
import tapEvent from 'lib/Tracking/ListingsCarousel/ImageTapEvent';
import { useRouter } from 'next/router';
import { MouseEvent, useContext } from 'react';
import VdpEventContext from 'contexts/VdpEventContext';
import useEvents from 'lib/hooks/useEvents';
import { SourcePages } from 'lib/EventSchema';
import { inIframe } from 'lib/Utilities';
import Link from 'next/link';
import DirectToVdpContext from 'contexts/DirectToVdpContext';
import { ListingViewModel } from '../types';
import styles from './styles';

interface ListingCardProp extends ListingViewModel {
  className?: string;
  isFavorited?: boolean;
}

function ListingCard({
  year,
  make,
  model,
  mileageUnformatted,
  price,
  city,
  state,
  vin,
  vdpUrl,
  primaryPhotoUrl,
  isFavorited,
  className = '',
}: ListingCardProp): JSX.Element {
  const { t } = useTranslation();
  const { trackingParams } = useContext(VdpEventContext);
  const logger = useEvents();
  const router = useRouter();
  const { isDirectToVdp } = useContext(DirectToVdpContext);

  async function onClick(e: MouseEvent): Promise<void> {
    e.preventDefault();
    if (inIframe()) {
      window.parent.postMessage(['vdp', vdpUrl], '*'); // SRP is wrapping VDP in an iframe. Update url to match VDP, post an 'vdp' message.
    } else if (isDirectToVdp) {
      await router.push(vin);
      window.scrollTo(0, 0);
    } else {
      await router.push(vdpUrl);
      window.scrollTo(0, 0);
    }
    logger.log(tapEvent({ pathName: router.asPath as SourcePages, trackingParams }));
  }
  return (
    <>
      <Link href={vdpUrl} legacyBehavior>
        <a className={`similar-listing-card ${className}`} onClick={onClick}>
          <div data-testid="image" className="primary-photo">
            <div className={isFavorited ? 'favorite-heart' : ''} />
          </div>
          <div className="vehicle-details">
            <div className="primary">
              {year} {make} {model}
            </div>
            <div className="secondary">
              {t('vdp.mileageHumanized', { mileage: mileageUnformatted })} | {city}, {state}
            </div>
            <div className="price">{price}</div>
          </div>
        </a>
      </Link>
      <style jsx>{`
        .primary-photo {
          color: inherit;
          border: none;
          padding: 0;
          font: inherit;
          cursor: pointer;
          outline: inherit;

          background-image: url(${primaryPhotoUrl}),
            url(https://www.autolist.com/assets/listings/default_car.jpg);
        }
      `}</style>
      <style jsx>{styles}</style>
    </>
  );
}

export default ListingCard;
